import {
  JOB_DESCRIPTION_REQUEST, JOB_DESCRIPTION_SUCCESS, JOB_DESCRIPTION_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const JobDescriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOB_DESCRIPTION_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case JOB_DESCRIPTION_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case JOB_DESCRIPTION_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default JobDescriptionReducer;
